import React from "react";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L from "leaflet";
import "./MapComponent.css";
// Optional for additional styling

// Fixing default Marker icon issues in Leaflet
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png",
  iconUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png",
  shadowUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png",
});

export default function MapComponent() {
  const mapCenter = [12.9165, 75.6768]; // Coordinates for Puttur, Karnataka

  const locations = [
    { name: "Head Office", position: [12.750916122361337, 75.21424215447223] },
    { name: "Administrative Office", position: [12.761084024938507, 75.20063168974572] },
    {name: "Darbe Puttur", position: [12.750916122361337, 75.21424215447223]},
    { name: "Sullia", position: [12.555701807521544, 75.39187707365772] },
    { name: "Puttur", position: [12.7590, 75.2010] },
    { name: "B.C. Road", position: [12.881649300614546, 75.02983672049842] },
    { name: "Mangalore", position: [12.875822900586915, 74.84214862379162] },
    { name: "Puttur", position: [12.761164914915732, 75.20090141729786] },
    { name: "Sheshadripuram Bengaluru", position: [12.9932300, 77.5727770] },
    {name: "Belthangady", position: [12.989287911487965, 75.28027373888794]},
    {name:"Shirva", position: [13.218604301566232, 74.82197795480641]},
    {name: " Jayanagar", position:[12.9221244, 77.5971172]},
    {name: "Bellare", position: [12.6656971, 75.3705974]},
    {name: "Kadaba", position: [12.742214, 75.469799]},
    {name: "Vitla", position: [12.76293502258308, 75.10009619566019]},
    {name:"Virajpet", position: [12.1947021, 75.8056158]},
    {name: "T. Dasarahalli", position: [13.0528852, 77.5076276]},
    {name: "Surathkal", position: [12.987926538208171, 74.80224943827596]},
    {name:"Machohalli", position: [12.9855220, 77.4583420]},
    {name:"Gurupura Kaikamba", position: [12.96139339134632, 74.93261997470822]},
    {name:"Madantyar", position:[12.95176007769148, 75.1875284333768]},
    {name: "Mudipu", position:[12.802856397400346, 74.96357833296767]},
    {name: "Kalladka", position:[12.843010270092483, 75.07257703720468]},
      {name: "Nehru Nagar Puttur", position:[12.776280, 75.182829]},
      {name:"Nixon Plaza, Ullala bailu Post",position:[12.816028, 74.849611]},
     {
  name: "Siddakatte Bantwal",
  position: [12.994243, 75.052658]
}
  ];

  return (
    <div className="map-container">
    {/* List of Locations */}
    {/* <div className="location-list">
      <h3>Locations</h3>
      <ul>
        {locations.map((location, index) => (
          <li key={index}>{location.name}</li>
        ))}
      </ul>
    </div> */}

    {/* Map */}
    <div className="map-view">
      <MapContainer center={mapCenter} zoom={10} style={{ height: "100%", width: "100%" }}>
        <TileLayer
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        />
        {locations.map((location, index) => (
          <Marker key={index} position={location.position}>
            <Popup>{location.name}</Popup>
          </Marker>
        ))}
      </MapContainer>
    </div>
  </div>
  );
}
